<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <ion-header class="transparent" >
            <app-header class="dark-mode" *ngIf="report !== null"
                        [backRoute]="level === 'learner' ? ['/review'] : ['/review/team/', report.del_id]"
                        [middleIcon]="userService.companyLogo !== 'assets/icon/journey-logo.svg'"
                        [middleIconSize]="userService.companyLogoSize"
                        [backIconWork]="true" [@enter]>
            </app-header>
        </ion-header>
        <div class="bg bg-inner-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform === 'mobile'}" [@enter]></div>
        <app-manager-panel *ngIf="level === 'manager'"></app-manager-panel>
        <ng-container *ngIf="level === 'learner'">
            <div class="box" [@enter]>
                <div class="title">
                    <div>{{'__REVIEW_REPORT_TITLE__' | translate }}</div>
                </div>
                <div class="subtitle primary-color">{{'__REVIEW_REPORT_SUBTITLE__' | translate }}</div>
            </div>
        </ng-container>

        <div class="shadow-container" *ngIf="report === null">
            <app-review-skeleton></app-review-skeleton>
            <app-review-skeleton></app-review-skeleton>
            <app-review-skeleton></app-review-skeleton>
        </div>

        <form (ngSubmit)="onSubmit()" #form="ngForm" class="shadow-container" *ngIf="report !== null">
            <img (click)="goBack()" src="assets/img/close.svg" alt=""
                 style="position: absolute; top: 0.5rem; right: 0.5rem; height: 2.5rem; width: 2.5rem;">
            <div class="print-button" *ngIf="level === 'manager'" (click)="printReport($event)">
                <app-inline-svg class='download-report-btn' [file]="'assets/icon/report-download.svg'"></app-inline-svg>
            </div>
            <div class="padding-left-box">
                <div class="shadow-header font-header">
                    <span *ngIf="level === 'learner'">{{'__REVIEW_REPORT_NEW_PDR__' | translate }}</span>
                    <span *ngIf="level === 'manager'">{{report.delegate.full_name}} <span style="font-weight: normal;">- {{'__REVIEW_REPORT_NEW_PDR__' | translate }}</span></span>
                    <div style="border-bottom: 2px solid #8dc63f; width: 70%;"></div>
                </div>
                <div *ngIf="level === 'learner'" class="font-large">{{'__REVIEW_REPORT_FORM_LEARNER_CONTENT__' | translate }}</div>
                <div *ngIf="level === 'manager'" class="font-large">{{'__REVIEW_REPORT_FORM_REVIEW_PERIOD__' | translate }}:</div>
                <div class="input-group">
                    <input
                        [(ngModel)]="report.period.value"
                        (ngModelChange)="onFormChange($event)"
                        [disabled]="report.period.options.read_only"
                        name="period"
                        #period="ngModel"
                        type="text"
                        class="shadow-header"
                        [required]="report.period.options.required"
                        placeholder="{{'__REVIEW_REPORT_FORM_REVIEW_PERIOD_PLACEHOLDER__' | translate}}"
                        style="font-size: 1.375rem; width: 20rem; text-align: center; font-weight: normal; padding: 0 1rem .5rem; border-bottom: 2px solid #8dc63f">
                    <div *ngIf="period.invalid && (period.dirty || period.touched)" class="invalid-feedback">
                        <div *ngIf="period.errors?.['required']">{{'__REVIEW_REPORT_FORM_VALIDATE_REQUIRED__' | translate }}</div>
                    </div>
                </div>

                <div *ngIf="level === 'learner'" class="font-smaller">{{'__REVIEW_REPORT_FORM_LEARNER_CONTENT2__' | translate }}</div>
                <div *ngIf="level === 'manager'" class="font-smaller">{{'__REVIEW_REPORT_FORM_MANAGER_CONTENT2__' | translate }}</div>
            </div>
            <app-dropdown-box
                [title]="'__REVIEW_REPORT_FORM_SELF_TITLE__' | translate : {name : (level === 'manager' ? report.delegate.full_name : ('__REVIEW_REPORT_FORM_SELF_YOU__' | translate))}"
                [date]="selfUpdatedAt">
                <div class="dropdown-content">
                    <div class="font-larger">{{'__REVIEW_REPORT_FORM_SELF_CONTENT__' | translate }}</div>
                    <app-questionnaire-input
                        *ngFor="let answer of report.answers_self.value"
                        [title]="answer.question.title"
                        [hint]="answer.question.hint"
                        [(answer)]="answer.answer.value"
                        [disabled]="answer.answer.options.read_only"
                        class="line-top"
                    ></app-questionnaire-input>
                </div>
            </app-dropdown-box>
            <app-dropdown-box
                [title]="'__REVIEW_REPORT_FORM_SELF_TITLE__' | translate : {name : (level === 'manager' ? '__REVIEW_REPORT_FORM_SELF_YOU__' : '__REVIEW_REPORT_FORM_SELF_YOUR_MANAGER__') | translate}"
                [date]="managerUpdatedAt">
                <div class="dropdown-content">
                    <div class="font-larger" style="display: flex; flex-direction: column; gap: 1.5rem;" [innerHTML]="'__REVIEW_REPORT_FORM_MANAGER_CONTENT__' | translate"></div>
                    <div class="line-top" style="padding-top: .5rem;"></div>
                    <app-questionnaire-input
                        *ngFor="let answer of report.answers_manager.value"
                        [title]="answer.question.title"
                        [hint]="answer.question.hint"
                        [(answer)]="answer.answer.value"
                        [disabled]="answer.answer.options.read_only"
                    ></app-questionnaire-input>
                </div>
            </app-dropdown-box>
            <app-dropdown-box
                [title]="('__REVIEW_REPORT_FORM_GOALS_TITLE__' | translate) + (level === 'manager' ? ' (' + report.delegate.full_name + ')' : '')"
                [date]="recordsUpdatedAt">
                <div class="dropdown-content" style="gap: 1rem;">
                    <div class="font-larger">{{'__REVIEW_REPORT_FORM_GOALS_CONTENT__' | translate }}</div>
                    <app-dropdown-box [hasDate]="false" [title]="'__REVIEW_REPORT_FORM_GOALS_FEEDBACK_TITLE__' | translate" [color]="'green'">
                        <div class="bg-content feedback show">
                            <div class="table-header font-larger">
                                <div>{{'__REVIEW_REPORT_FORM_GOALS_FORM_NAME__' | translate}}</div>
                                <div class="ion-text-center">{{'__REVIEW_REPORT_FORM_GOALS_FORM_DATE__' | translate}}</div>
                                <div></div>
                            </div>
                            <div class="objective-wrapper">
                                <app-feedback [feedback]="feedback" *ngFor="let feedback of report.feedbacks; let i = index;">
                                    <div class="dropdown-content" style="padding: 0; width: 100%;">
                                        <app-questionnaire-text
                                            *ngFor="let answer of feedback.feedback_answers"
                                            [title]="answer.question.title"
                                            [hint]="answer.question.hint"
                                            [answer]="answer.answer"
                                            [disabled]="true"
                                            class="smaller smaller-fonts">
                                        </app-questionnaire-text>
                                    </div>
                                </app-feedback>
                            </div>
                        </div>
                    </app-dropdown-box>
                    <app-dropdown-box style="position: relative;" [hasDate]="false" [title]="'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_TITLE__' | translate" [color]="'green'">
                        <div [ngClass]="{'show': showCompletedGoals, 'objective-filter': level === 'learner'}" class="bg-content">
                            <div class="table-header font-larger">
                                <div>{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_FORM_TITLE__' | translate }}</div>
                                <div></div>
                                <div class="ion-text-center">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_FORM_CREATED__' | translate }}</div>
                                <div class="ion-text-center">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_FORM_DURATION__' | translate }}</div>
                                <div class="ion-text-center">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_FORM_STATUS__' | translate }}</div>
                            </div>
                            <div class="objective-wrapper" *ngIf="level === 'learner'">
                                <app-objective
                                    *ngFor="let objective of report.goals.value | filter : 'status' : true; let i = index;"
                                    (onChange)="onObjectiveStatusChange(objective.id, objective.status)"
                                    [objective]="objective">
                                    <div class="dropdown-content" style="padding: 0; width: 100%;">
                                        <app-questionnaire-input
                                            *ngFor="let answer of objective.goal_answers.value"
                                            [title]="answer.question.title"
                                            [hint]="answer.question.hint"
                                            [(answer)]="answer.answer.value"
                                            [disabled]="true"
                                            class="smaller smaller-fonts">
                                        </app-questionnaire-input>
                                    </div>
                                </app-objective>
                            </div>
                            <div class="objective-wrapper" *ngIf="level === 'manager'">
                                <app-objective
                                    *ngFor="let objective of report.goals.value; let i = index;"
                                    [objective]="objective">
                                    <div class="dropdown-content" style="padding: 0; width: 100%;">
                                        <app-questionnaire-input
                                            *ngFor="let answer of objective.goal_answers.value"
                                            [title]="answer.question.title"
                                            [hint]="answer.question.hint"
                                            [(answer)]="answer.answer.value"
                                            [disabled]="answer.answer.options.read_only"
                                            class="smaller smaller-fonts">
                                        </app-questionnaire-input>
                                    </div>
                                </app-objective>
                            </div>
                            <div class="notifications" *ngIf="level === 'learner'">
                                <div style="font-weight: 600;">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_PREVIOUS__' | translate }}</div>
                                <ion-toggle
                                  class="black-toggle"
                                  [attr.data-label-on]="'__ION_TOGGLE_YES__' | translate"
                                  [attr.data-label-off]="'__ION_TOGGLE_NO__' | translate"
                                  [checked]="showCompletedGoals" (ionChange)="showCompletedGoals = !showCompletedGoals"
                                  mode="ios"></ion-toggle>
                            </div>
                        </div>
                        <div class="dropdown-content large-line-top" *ngIf="level === 'learner'">
                            <ng-container *ngFor="let objective of report.goals_uncompleted.value | filter : 'deleted.value' : false; let i = index">
                                <app-objective-form
                                    [groupName]="'objective_' + i"
                                    [(title)]="objective.title.value"
                                    [(duration)]="objective.duration.value"
                                    [disabled]="objective.title.options.read_only"
                                    class="objective-container">
                                    <div class="add-objective-element">
                                        <div class="dropdown-content" style="padding: 0;">
                                            <app-questionnaire-input
                                                *ngFor="let answer of objective.goal_answers.value"
                                                [title]="answer.question.title"
                                                [hint]="answer.question.hint"
                                                [(answer)]="answer.answer.value"
                                                [disabled]="answer.answer.options.read_only"
                                                class="smaller smaller-fonts">
                                            </app-questionnaire-input>
                                        </div>
                                        <div class="form-actions-wrap">
                                            <img src="assets/img/{{ objective.status.value ? 'tick-large-icon-active.svg' : 'tick-large-icon.svg' }}"
                                                 alt="Goal Status Change"
                                                 (click)="onObjectiveStatusChange(objective.id, objective.status.value)">
                                            <img (click)="removeGoal(i, objective)"
                                                 class="touch-eff-radius"
                                                 src="assets/img/trash-icon.svg"
                                                 alt="">
                                        </div>
                                    </div>
                                </app-objective-form>
                            </ng-container>
                            <img
                                *ngIf="report.goals_uncompleted.options.read_only === false"
                                (click)="addGoal()"
                                class="touch-eff-radius"
                                style="margin: auto; width: 5rem;"
                                src="assets/img/add-black.svg"
                                alt="">
                        </div>
                    </app-dropdown-box>
                    <app-dropdown-box [hasDate]="false" [title]="'__REVIEW_REPORT_GOALS_SIX_MONTH_NOTES__' | translate" [color]="'green'">
                        <div class="dropdown-content" style="flex-direction: row; align-items: flex-end;">
                            <app-questionnaire-input
                                *ngFor="let answer of report.answers_note.value; let i = index;"
                                [title]="answer.question.title"
                                [hint]="answer.question.hint"
                                [(answer)]="answer.answer.value"
                                [disabled]="answer.answer.options.read_only"
                                style="width: 100%;"
                            ></app-questionnaire-input>
                            <img *ngIf="false && level === 'learner'" src="assets/img/trash-icon.svg" alt="">
                        </div>
                    </app-dropdown-box>
                </div>
            </app-dropdown-box>
            <div class="meeting-box">
                <div class="switch">
                    <div class="meeting-switch-label">{{'__REVIEW_REPORT_MEETING_CONFIRMED__' | translate}}</div>
                    <div class="meeting-switch-toggle">
                        <app-readonly [readonly]="report.is_meeting_confirmed.options.read_only">
                            <ion-toggle
                              [attr.data-label-on]="'__ION_TOGGLE_YES__' | translate"
                              [attr.data-label-off]="'__ION_TOGGLE_NO__' | translate"
                              (ngModelChange)="onFormChange($event)"
                              [disabled]="report.is_meeting_confirmed.options.read_only"
                              class="black-toggle" [(ngModel)]="report.is_meeting_confirmed.value"
                              name="is_meeting_confirmed" ></ion-toggle>
                        </app-readonly>
                    </div>
                </div>
                <div class="date">
                    <div class="meeting-date-label">{{'__REVIEW_REPORT_MEETING_DATE__' | translate}}:</div>
                    <div class="meeting-date-datepicker">
                        <app-readonly [readonly]="report.meeting_at.options.read_only">
                            <app-datepicker
                              (ngModelChange)="onFormChange($event)"
                              name="meeting_at"
                              [disabled]="report.meeting_at.options.read_only"
                              [locale]="userService.userInfo.language.code"
                              [(date)]="report.meeting_at.value"
                            ></app-datepicker>
                        </app-readonly>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ion-content>
<ion-footer *ngIf="!isSaved" class="swiper-no-swiping">
    <app-footer (saveEvent)="onSubmit()" [backButton]="false" [saveButton]="true" [isSaving]="isSaving"></app-footer>
</ion-footer>
